import moment from 'moment'
// import 'moment/locale/th'
import 'moment/dist/locale/th';
export default {
  install: (app) => {
    app.config.globalProperties.$moment = moment
    app.config.globalProperties.$moment.locale('th')
  }
}